/* eslint-disable no-undef */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

const getHeight = () => {
  const currentHeight = window?.innerHeight

  return `${currentHeight - 150}px`
}

const DashboardBoldBI = ({ id, config }) => {
  useEffect(() => {
    const create = BoldBI.create({
      serverUrl: config.serverUrl,
      dashboardId: config.dashboardId,
      embedContainerId: id,
      embedType: BoldBI.EmbedType.Component,
      environment: BoldBI.Environment.Enterprise,
      mode: BoldBI.Mode.View,
      height: config.height ? config.height : getHeight(),
      width: '100%',
      dashboardSettings: {
        showExport: false
      },
      localeSettings: {
        culture: 'pt-BR'
      },
      authorizationServer: config.authorizationServer,
      expirationTime: '100000'
    })

    create.loadDashboard()
  }, [config])

  return <div id={id} />
}

DashboardBoldBI.propTypes = {
  id: PropTypes.string.isRequired,
  config: PropTypes.shape({
    serverUrl: PropTypes.string,
    dashboardId: PropTypes.string,
    authorizationServer: PropTypes.shape({
      url: PropTypes.string,
      headers: PropTypes.shape({
        'x-api-key': PropTypes.string,
        Authorization: PropTypes.string
      })
    }),
    height: PropTypes.string
  }).isRequired
}

export default DashboardBoldBI
